module.exports = __webpack_public_path__ + "img/icon-12.e1e38c83.png";